import React, { FC } from "react";
import { RenderChapter } from "src/components/RenderChapter";
import { PRIVACY_POLICY_CONTENT } from "./constants";
import { useTranslation } from "react-i18next";
import { privacyPolicyTrns } from "./trns";

export const PrivacyPolicyInfo: FC = () => {
  const { t } = useTranslation();

  return (
    <section className="container">
      <h1 className="text-purple-base text-28 font-semibold">
        {t(privacyPolicyTrns.title)}
      </h1>

      <RenderChapter
        className="max-w-200 mt-10"
        sections={PRIVACY_POLICY_CONTENT}
      />
    </section>
  );
};
